import * as Mod1 from "./discourse/components/unified-search-header-icon";
import * as Mod2 from "./discourse/controllers/find";
import * as Mod3 from "./discourse/find-route-map";
import * as Mod4 from "./discourse/initializers/unified-search";
import * as Mod5 from "./discourse/routes/find";
import * as Mod6 from "./discourse/templates/find";
const compatModules = {
  "discourse/components/unified-search-header-icon": Mod1,
  "discourse/controllers/find": Mod2,
  "discourse/find-route-map": Mod3,
  "discourse/initializers/unified-search": Mod4,
  "discourse/routes/find": Mod5,
  "discourse/templates/find": Mod6,
};
export { compatModules };
export default compatModules;
